<template>
    <div class="creator-search-results">
        <h2 v-if="Object.keys(data).length" class="creator-search-results__heading">Select the words that you’re interested in from the tables below to add them to your word bank, found in the <a href="javascript;" class="fw-700" @click="brandCentreLinkClickHandler($event)">My Brand Centre tab</a></h2>

        <div class="creator-search-results__accordion" v-for="(item, key) in data" :key="key">
            <CreatorAccordion :data="item" :title="key" :key="key" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreatorAccordion from './CreatorAccordion.vue';

export default {
    name: 'CreatorSearchResults',
    components: {
        CreatorAccordion,
    },
    props: ['data', 'searchID'],
    data() {
        return {
            selectedWords: []
        }
    },
    computed: {
        ...mapGetters('BrandCentre', {
            wordBank: 'getWordBankWords',
        })
    },
    watch: {
        selectedWords: function (data) {
            this.$emit('wordbank-updated', data);
        }
    },
    methods: {
        ...mapActions('BrandCentre', {
            toggleBrandCentre: 'toggleBrandCentreVisibility',
        }),
        brandCentreLinkClickHandler(e) {
            e.preventDefault();
            this.toggleBrandCentre();
        }
    }
}
</script>